import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'

import { useUser } from '@/hooks/useUser'

export type UserFormData = string | number | boolean | object | undefined // "John Doe" | 123 | true | { code: "us", name: "The United States" }

export interface UserFormContextProps {
  userForm: Record<string, UserFormData> | null
  setUserForm: Dispatch<SetStateAction<UserFormContextProps['userForm']>>
}

export const UserFormContext = createContext({} as UserFormContextProps)

interface UserFormProviderProps {
  children: ReactNode
}

export const UserFormProvider = ({ children }: UserFormProviderProps) => {
  const { user } = useUser()
  const [userForm, setUserForm] = useState<UserFormContextProps['userForm']>(user?.data ? user.data : null)

  useEffect(() => {
    if (!userForm) return

    localStorage.setItem('userForm', JSON.stringify(userForm))
  }, [userForm])

  useEffect(() => {
    const lsUserForm = localStorage.getItem('userForm')
    setUserForm(lsUserForm ? JSON.parse(lsUserForm) : {})
  }, [])

  const value = {
    userForm,
    setUserForm
  }

  return <UserFormContext.Provider value={value}>{children}</UserFormContext.Provider>
}
